/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */
import { loadAnalyticsConfig } from './analyticsConfig.js';
let started = false;
let projectId = '';

function applySearchConsole(token) {
  if (!token || document.querySelector('meta[name="google-site-verification"]')) return;
  const m = document.createElement('meta');
  m.name = 'google-site-verification';
  m.content = token;
  document.head.appendChild(m);
}

function start() {
  if (started || window.clarity || !projectId) return;
  started = true;
  window.clarity = function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(projectId) + '?ref=bwt';
  document.head.appendChild(s);
}

export async function initClarity() {
  if (typeof window === 'undefined') return;
  try {
    const cfg = await loadAnalyticsConfig();
    projectId = cfg.clarity_id || '';
    applySearchConsole(cfg.gsc_verification);
  } catch {
    return;
  }
  if (!projectId) return;
  const consent = window.SeqConsent;
  if (!consent || consent.allowed('stat')) start();
  if (consent) consent.onChange((c) => {
    if (c.stat) {
      if (started && typeof window.clarity === 'function') window.clarity('start');
      else start();
    }
  });
}
